import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, CardV2, CardBody, CardContent, CardFooter, Col, Row } from '@si-armes/dsfr-react';
import styles from './InformationsAdresse.module.scss';
import RoutesMonCompte from '../../pages/espace-detenteurs/mon-compte/routes';
import { getPath } from '../../utils/router';

const InformationAdresse = ({ adresse, titre, afficherBoutonAction }) => {
    const history = useHistory();
    const { numVoie, extension, libelleVoie, lieuDit, codePostal, ville, id } = adresse;
    const modificationAdresse = () => {
        history.push(
            getPath(RoutesMonCompte.subroutes.adressePrincipale, {
                idAdresse: id,
            }),
        );
    };

    return (
        <>
            <CardV2 size="lg" noEnlargeLink>
                <CardBody>
                    <CardContent>
                        <div className={styles.informationsAdresseContainer}>
                            <div className={styles.informationsAdresseContainer__informations}>
                                {titre && (
                                    <>
                                        <Row>
                                            <Col col={12}>
                                                <div
                                                    className={
                                                        styles.informationsAdresseContainer__informations__titre
                                                    }
                                                >
                                                    <span
                                                        className="fr-icon-home-4-fill icon-color"
                                                        aria-hidden="true"
                                                    />{' '}
                                                    {titre}
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                <div
                                    className={
                                        styles.informationsAdresseContainer__informations__line
                                    }
                                >
                                    {numVoie} {extension} {libelleVoie} {lieuDit}
                                </div>
                                <div
                                    className={
                                        styles.informationsAdresseContainer__informations__line
                                    }
                                >
                                    {codePostal} {ville}
                                </div>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter>
                        {afficherBoutonAction && (
                            <div className={styles.informationsAdresseContainer__boutons}>
                                <Button
                                    icon="fr-fi-edit-line"
                                    iconPosition="left"
                                    onClick={modificationAdresse}
                                    variant="secondary"
                                >
                                    Modifier mon adresse
                                </Button>
                            </div>
                        )}
                    </CardFooter>
                </CardBody>
            </CardV2>
        </>
    );
};

InformationAdresse.propTypes = {
    adresse: PropTypes.shape({
        id: PropTypes.number,
        numVoie: PropTypes.string,
        extension: PropTypes.string,
        libelleVoie: PropTypes.string,
        lieuDit: PropTypes.string,
        codePostal: PropTypes.string,
        ville: PropTypes.string,
    }),
    titre: PropTypes.string,
    afficherBoutonAction: PropTypes.bool,
};

export default connect()(InformationAdresse);
